import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import adsExcluded from '../../data/adsExcluded'
import Content from '../../components/layout/Content'
import { mobile, VIEWPORT_DESKTOP, VIEWPORT_MOBILE } from '../../styles/media'
import { withRouter } from 'react-router-dom'
import translate from '../../helper/translate'

const AdSlot = ({ authToken, desktopOnly, marginBottom, mobileOnly, name, siteError, t, viewport }) => {
	if (authToken || siteError) return null

	if (adsExcluded.find(item => location.pathname.startsWith(item))) {
		return null
	}

	if (desktopOnly && viewport !== VIEWPORT_DESKTOP) {
		return null
	}

	if (mobileOnly && viewport !== VIEWPORT_MOBILE) {
		return null
	}

	if (name === 'header' || name === 'incontent_footer') {
		return (
			<StyledContent>
				<Inner $name={name}>
					<StyledAdSlot id={name} data-fuse={name} marginBottom={marginBottom} text={t('general.ad')} />
				</Inner>
			</StyledContent>
		)
	}

	return <StyledAdSlot id={name} data-fuse={name} marginBottom={marginBottom} text={t('general.ad')} />
}

AdSlot.propTypes = {
	authToken: PropTypes.string,
	siteError: PropTypes.string,
	location: PropTypes.object.isRequired,
	marginBottom: PropTypes.string,
	name: PropTypes.string.isRequired,
	t: PropTypes.func.isRequired,
	viewport: PropTypes.string.isRequired
}

AdSlot.defaultProps = {
	authToken: null,
	marginBottom: null,
	siteError: null
}

export const StyledAdSlot = styled.div`
	position: relative;

	border-radius: 12px;
	padding: 1rem;

	align-items: center;
	display: flex;
	justify-content: center;

	${props => props['data-fuse'] !== 'header' && `
		background: ${props.theme.backgroundVeryLight};
		min-height: calc(250px + 2rem);
	`}

	${props => props['data-fuse'] === 'header' && `
		height: calc(90px + 2rem);
	`}

	${props => props['data-fuse'] === 'vrec_4' && `
		height: calc(600px + 2rem);
		width: calc(300px + 2rem);

		position: sticky;
		top: 1rem;
		z-index: 1;
	`}

	${props => (props['data-fuse'] === 'incontent_1' || props['data-fuse'] === 'incontent_2' || props['data-fuse'] === 'incontent_3' || props['data-fuse'] === 'incontent_4') && `
		min-height: calc(90px + 2rem);
	`}

	${props => props.marginBottom && `
		margin-bottom: ${props.marginBottom};
	`}

	&:after {
		color: ${props => props.theme.textVeryLight};
		content: "${props => props.text}";
		font-size: 0.6rem;

		position: absolute;
		right: 0;
		bottom: -1rem;
	}
`

const StyledContent = styled(Content)`
	margin-bottom: 1rem;
	padding: 0 2rem 0 !important;

	${mobile`
		padding: 0 1rem 0 !important;
	`}
`

const Inner = styled.div`
	background: ${props => props.theme.backgroundVeryLight};
	border-radius: 12px;
`

const enhance = compose(
	connect(state => ({
		authToken: state.persist.authToken,
		siteError: state.app.siteError,
		viewport: state.app.viewport
	})),
	translate('general'),
	withRouter
)

export default enhance(AdSlot)
